<template><div><h1 id="jahrliche-austritte" tabindex="-1"><a class="header-anchor" href="#jahrliche-austritte"><span>Jährliche Austritte</span></a></h1>
<p>Zusagen, jährliche Austritte — Bereinigung Zusager-Status von Personen ohne Beitragszahlung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Bereinigung der Zusagen. Z.B. am Jahresende kann es sinnvoll sein, für Zusagen, deren Beiträge auch nach wiederholter Mahnung nicht bezahlt worden sind, Austritte zu erfassen. Es werden nur Zusagen mit Zahlungsmodus ESR (unabhängig vom Kanal, also auch ESR per E-Mail) berücksichtigt, die für das eingegebene Grenzjahr keine Zahlung geleistet haben. Nicht berücksichtigt werden Zusagen, die nur einen Teilbetrag einbezahlt haben.</p>
<p>Vor dem Start dieses Programmes sollte eine Analyse den Zustand der aktuellen Zusagen überprüfen und Antworten geben auf folgende Fragen:</p>
<ul>
<li>
<p>Welche Zusagen sollen bereinigt werden?</p>
</li>
<li>
<p>Wieviele Zusagen bestehen im System, und wieviele wären von einer Bereinigung betroffen? (Zähllauf)</p>
</li>
<li>
<p>Wie lange dauert es üblicherweise, bis ein Zusager, der einen Einzahlungsschein erhalten hat, auch tatsächlich eine Zahlung leistet?</p>
</li>
<li>
<p>Sollen Zusager, welche mehrere Jahre ihre Zusage bezahlt haben, im aktuellen Jahr aber nicht mehr, aus den Zusagen entfernt werden?</p>
</li>
<li>
<p>Wie sollen Zusager behandelt werden, die nicht den vollen zugesagten Betrag einbezahlt haben?</p>
</li>
<li>
<p>Welche Kommunikationsmassnahmen wurden zur Verringerung der Nichtzahler durchgeführt und haben diese den erwarteten Erfolg gehabt?</p>
</li>
</ul>
<p>Nach Beantwortung dieser Fragen kann das Programm mit den entsprechenden Parametern versehen und die Bereinigung durchgeführt werden.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Zusagen → Jährliche Austritte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>LaufNr.</dt>
<dd>Fortlaufende Nummer (automatisch vom System vergeben).</dd>
<dt>Zusageart</dt>
<dd><a class="link" href="ft.refdata.tblzusart.html" title="Zusagen">Zusage</a> , die bearbeitet werden soll.</dd>
<dt>Austrittsdatum</dt>
<dd>Austrittsdatum, welches durch das Programm gesetzt werden soll.</dd>
<dt>Grenzdatum</dt>
<dd>Beim Bereinigungslauf sollen jene Zusagen, die noch gar nicht die Möglichkeit hatten, eine Zahlung für das laufende Jahr zu machen, nicht berücksichtigt werden.</dd>
<dt>Grenzjahr</dt>
<dd>Definiert jene Zusagen, die im Bereinigungslauf - trotz fehlender Beitragszahlung - nicht berücksichtigt werden sollen.<br>Alle Zusagen, deren Eintrittsdatum vor dem einzugebenden &quot;Grenzdatum&quot; liegt und für die zugleich kein Beitrag für das hier einzugebende &quot;Grenzjahr&quot; eingegangen ist, werden als &quot;ausgetreten&quot; registriert und erhalten den Ausgetreten-Status &quot;Ex&quot;.<br>Beispiel: Wenn Grenzdatum = 01.05.2015 und Grenzjahr = 2015 definiert ist, dann wird bei allen Personen, bei denen die Zusage vor dem 01.05.2015 aufgenommen wurde (Eintritsdatum der Zusage) und die keinen Beitrag für das Jahr 2015 bezahlt haben, die Zusage als Ex-Zusage geführt. Solche die den Betrag für das Jahr 2015 nicht bezahlt haben, aber schon für das Jahr 2016 bezahlt haben, werden hingegen nicht berücksicht, resp. gelten als bezahlt und werden nicht ausgetreten.</dd>
<dt>Ausschlussfilter</dt>
<dd>Die im Filter enthaltenen Adressen werden nicht berücksichtigt. Es handelt sich nicht um einen Online-Filter, der Filter muss vorgängig markiert sein.</dd>
<dt>Ereignis</dt>
<dd>Austrittsereignis, das mit der Zusage verknüpft werden soll.</dd>
<dt>Ereignisposition</dt>
<dd>Austrittsereignisposition, das mit der Zusage verknüpft werden soll.</dd>
<dt>Status</dt>
<dd>Die folgenden Status sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst, noch nicht aufbereitet</td>
<td>Der Job ist erfasst aber noch nicht aufbereitet.</td>
</tr>
<tr>
<td>Zählung läuft</td>
<td>Die Anzahl auszutretenden Zusagen werden gezählt.</td>
</tr>
<tr>
<td>aufbereitet</td>
<td>Der Job wurde aufbereitet und die Austritte wurden durchgeführt.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Anzahl</dt>
<dd>Anzahl der Austritte.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten...</span></a></h3>
<p>Mit diesem Job werden bei den Zusagen die Austritte gesetzt, vorgängig kann eine Zählung für die Ermittlung der Anzahl auszutrenden Zusagen durchgeführt werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.zusjaustr.html" title="Aufbereiten...">Aufbereiten...</RouteLink></p>
</div></template>


